import Vue from 'vue';
import Router from 'vue-router';
import Index from './pages/Index.vue';

import LandingPage from './pages/LandingPage.vue';
import AboutUs from './pages/AboutUs.vue';
import Certification from './pages/Certification.vue';
import Facilities from './pages/Facilities.vue';
import Portofolio from './pages/Portofolio.vue';
import Service from './pages/Service.vue';
import Product from './pages/Product.vue';
import DetailProductVessel from './pages/DetailProductVessel.vue';
import DetailProductHe from './pages/DetailProductHe.vue';
import DetailProductPiping from './pages/DetailProductPiping.vue';
import DetailProductTower from './pages/DetailProductTower.vue';
import DetailProductMufle from './pages/DetailProductMufle.vue';
import DetailProductRadiant from './pages/DetailProductRadiant.vue';
import DetailProductOther from './pages/DetailProductOther.vue';
import DetailProductService from './pages/DetailProductService.vue';
import DetailServicePatching from './pages/DetailServicePatching.vue';
import DetailServicePiping from './pages/DetailServicePiping.vue';
import DetailServiceReshell from './pages/DetailServiceReshell.vue';
import DetailServiceRetubing from './pages/DetailServiceRetubing.vue';
import Blog from './pages/Blog.vue';
import Career from './pages/Career.vue';
import DetailBlog from './pages/DetailBlog.vue';
import FactoryTour from './pages/FactoryTour.vue';
import Seminar from './pages/Seminar.vue';
import ContactUs from './pages/ContactUs.vue';
import Login from './pages/Login.vue';

import Landing from './pages/Landing.vue';
import Profile from './pages/Profile.vue';
import MainNavbar from './layout/MainNavbar.vue';
import MainFooter from './layout/MainFooter.vue';
import { updateHead } from './utils/head';

import AdminLayout from './pages/admin/AdminLayout.vue';
import AdminFactoryRequest from './pages/admin/AdminFactoryRequest.vue';
import AdminSeminar from './pages/admin/AdminSeminar.vue';
import AdminBlog from './pages/admin/AdminBlog.vue';
import AdminBlogForm from './pages/admin/AdminBlogForm.vue';
import AdminCareer from './pages/admin/AdminCareer.vue';
import AdminCareerForm from './pages/admin/AdminCareerForm.vue';

Vue.use(Router);

const vurRouter = new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'LandingPage',
      components: { default: LandingPage, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/about-us',
      name: 'AboutUs',
      components: { default: AboutUs, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/certification',
      name: 'Certification',
      components: { default: Certification, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/facilities',
      name: 'Facilities',
      components: { default: Facilities, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/portofolio',
      name: 'Portofolio',
      components: { default: Portofolio, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/service',
      name: 'Service',
      components: { default: Service, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/product',
      name: 'Product',
      components: { default: Product, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/detail-product-vessel',
      name: 'DetailProductVessel',
      components: { default: DetailProductVessel, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/detail-product-he',
      name: 'DetailProductHe',
      components: { default: DetailProductHe, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/detail-product-piping',
      name: 'DetailProductPiping',
      components: { default: DetailProductPiping, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/detail-product-tower',
      name: 'DetailProductTower',
      components: { default: DetailProductTower, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/detail-product-mufle',
      name: 'DetailProductMufle',
      components: { default: DetailProductMufle, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/detail-product-radiant',
      name: 'DetailProductRadiant',
      components: { default: DetailProductRadiant, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/detail-product-other',
      name: 'DetailProductOther',
      components: { default: DetailProductOther, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/detail-product-service',
      name: 'DetailProductService',
      components: { default: DetailProductService, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/detail-service-patching',
      name: 'DetailServicePatching',
      components: { default: DetailServicePatching, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/detail-service-piping',
      name: 'DetailServicePiping',
      components: { default: DetailServicePiping, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/detail-service-shell',
      name: 'DetailServiceReshell',
      components: { default: DetailServiceReshell, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/detail-service-retubing',
      name: 'DetailServiceRetubing',
      components: { default: DetailServiceRetubing, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/blog',
      name: 'Blog',
      components: { default: Blog, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/career',
      name: 'Career',
      components: { default: Career, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/detail-blog/:code',
      name: 'DetailBlog',
      components: { default: DetailBlog, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/factory-tour',
      name: 'FactoryTour',
      components: { default: FactoryTour, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/seminar',
      name: 'Seminar',
      components: { default: Seminar, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/contact-us',
      name: 'ContactUs',
      components: { default: ContactUs, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/index-app',
      name: 'IndexApp',
      components: { default: Index, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/landing',
      name: 'landing',
      components: { default: Landing, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/login',
      name: 'login',
      components: { default: Login, header: MainNavbar },
      props: {
        header: { colorOnScroll: 400 }
      }
    },
    {
      path: '/profile',
      name: 'profile',
      components: { default: Profile, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/admin',
      component: AdminLayout,
      redirect: '/admin/blog',
      children: [
        { path: 'blog', name: 'admin.blog', component: AdminBlog },
        { path: 'blog/create', name: 'admin.blog.create', component: AdminBlogForm },
        { path: 'blog/:id/edit', name: 'admin.blog.edit', component: AdminBlogForm },
        { path: 'careers', name: 'admin.careers', component: AdminCareer },
        { path: 'careers/create', name: 'admin.careers.create', component: AdminCareerForm },
        { path: 'careers/:id/edit', name: 'admin.careers.edit', component: AdminCareerForm },
        { path: 'factory-request', name: 'admin.factoryRequest', component: AdminFactoryRequest },
        { path: 'seminar', name: 'admin.seminar', component: AdminSeminar }
      ]
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

vurRouter.beforeEach((to, from, next) => {
  if (to.path.startsWith('/admin')) {
    const ftAdminToken = localStorage.getItem('ft_admin_token');
    if (!ftAdminToken) {
      return next({ name: 'login' });
    }
    return next();
  }

  if (to.name === 'login' && localStorage.getItem('ft_admin_token')) {
    return next({ name: 'admin.blog' });
  }

  next();
})

vurRouter.afterEach((to) => {
  updateHead(to);
})

export default vurRouter;
